module.exports = __webpack_public_path__ + "v4assets/explorer-screenshot-dark.95a6ebf8fa4f8a47adc8f72b42a1bd63.png";